import { Box } from '@mui/material'

interface SparklineProps {
  values: number[]
  width?: number
  height?: number
  color?: string
  // Score range for normalization. Defaults to 0-10 since all our
  // dimensions live there. Pass [0, 1] for ratios, etc.
  domain?: [number, number]
}

/**
 * Minimal inline trend indicator. Renders a line through the value series
 * with a filled dot at the most recent point. Designed to fit inside a
 * card cell or next to a big number, not as a standalone chart.
 */
const Sparkline = ({
  values,
  width = 80,
  height = 24,
  color = '#1976d2',
  domain = [0, 10],
}: SparklineProps) => {
  if (!values || values.length < 2) {
    return <Box sx={{ width, height }} />
  }
  const [lo, hi] = domain
  const range = hi - lo || 1
  const stepX = width / (values.length - 1)
  const points = values.map((v, i) => {
    const x = i * stepX
    const y = height - ((v - lo) / range) * height
    return { x, y: Math.max(1, Math.min(height - 1, y)) }
  })
  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ')
  const last = points[points.length - 1]
  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      <path d={path} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" />
      <circle cx={last.x} cy={last.y} r={2.5} fill={color} />
    </svg>
  )
}

export default Sparkline
